import {
    IQueryFilter,
    IAttrQueryBase,
    IAttrQueryFilterFieldValue
} from '../../../_common/platform/tsx/filtering/Interfaces';

import { validators as platformValidators } from '../../../_common/platform/ts/validators';
import { AGGREGATIONS } from '../../../_common/platform/ts/ConfigurationConstants';
import * as FilterUtilities from '../../../_common/platform/tsx/filtering/FilterUtilities';
import { getExpressionType } from '../../../pdc-platform/src/ts/stores/EntityModelsStore';

export const validators = {
    localFilter: {
        validate: (value: IAttrQueryFilterFieldValue | IQueryFilter[]): string[] => {
            if (value == null) {
                return null;
            }

            if (Array.isArray(value)) {
                return validators.localFilter.validateFilters(value);
            } else {
                return validators.localFilter.validateFilters(value.filters);
            }
        },

        validateFilters: (value: IQueryFilter[]): string[] => {
            let result: string[];

            if (value != null && value.length > 0) {
                for (let i = 0; i < value.length; i++) {
                    const filter = value[i];
                    const filterLeft = filter.left;
                    const filterRight = filter.right;

                    if (filterLeft != null && filterRight != null) {
                        if (filterLeft.length === 0 || filterRight.length === 0) {
                            result = ['OR Filter is not fully defined'];
                            break;
                        } else {
                            result = validators.localFilter.validateFilters(filterLeft);

                            if (result == null) {
                                result = validators.localFilter.validateFilters(filterRight);
                            }

                            if (result != null) {
                                break;
                            }
                        }
                    } else {
                        let attributeText = filter.attribute;
                        let attributeType: string;

                        if (filter.expression != null) {
                            if (attributeText == null) {
                                attributeText = filter.expression.text || 'Expression';
                            }

                            attributeType = getExpressionType(filter.expression);

                            if (attributeType == null) {
                                if (result == null) {
                                    result = [];
                                }

                                result.push(
                                    `Return value's type of '${attributeText}' Expression is unknown. Expression is not valid.`
                                );
                                break;
                            }
                        }

                        const relation = filter.relation;
                        const valueType = FilterUtilities.getValueType(filter);
                        const filterValue = filter.value;
                        const valueIsEmpty =
                            filterValue == null ||
                            filterValue.length === 0 ||
                            (Array.isArray(filterValue) && filterValue.length === 0);

                        if (valueIsEmpty) {
                            if (valueType === 'variable') {
                                if (result == null) {
                                    result = [];
                                }

                                result.push(`Variable Name is not defined for '${attributeText}' Filter.`);
                                break;
                            } else if (FilterUtilities.isConstantValueType(valueType)) {
                                if (!FilterUtilities.filterValueTypeCannotBeChanged(attributeType, relation)) {
                                    if (result == null) {
                                        result = [];
                                    }

                                    result.push(`Value is not defined for '${attributeText}' Filter.`);
                                }
                            }
                        }
                    }
                }
            }

            return result;
        }
    },

    attributesParameterField: {
        validateLocalFilter: (value: { attrQueryFilter: IQueryFilter[] }) => {
            if (value != null) {
                return validators.localFilter.validate(value.attrQueryFilter);
            }
            return null;
        },

        validateGroupingAttributes: (value: { attrQuery?: IAttrQueryBase[] }) => {
            if (value != null) {
                const attrQueries = value.attrQuery;
                const numberOfAttributes = attrQueries != null ? attrQueries.length : 0;

                if (numberOfAttributes === 0) {
                    return null;
                }

                let attributesWithAggregation: number = 0;
                //let attributesWithoutAggregation: number = 0;
                let attributesWithGrouping: number = 0;
                //let expression: number = 0;

                for (let i = 0; i < numberOfAttributes; i++) {
                    const aggregate = attrQueries[i].aggregateGroup;

                    // if (attrQueries[i].expression != null) {
                    //     expression++;
                    // }

                    if (aggregate == null || aggregate === AGGREGATIONS.NONE || aggregate === '') {
                        //attributesWithoutAggregation++;
                    } else {
                        if (aggregate === 'group') {
                            attributesWithGrouping++;
                        }

                        attributesWithAggregation++;
                    }
                }

                if (attributesWithAggregation > 0) {
                    // See Issue 98404.
                    // if (attributesWithoutAggregation - expression > 0) {
                    //     return ['Either all or none of attributes must have aggregation function'];
                    // } else
                    if (attributesWithGrouping === numberOfAttributes) {
                        return ['At least one non grouping attribute must exist'];
                    }
                }
            }

            return null;
        }
    },

    number: {
        shouldBe: (value: number, errorMessage: string) => {
            if (platformValidators.number.shouldBe(value) == null) {
                return;
            }

            return [errorMessage];
        }
    },

    date: {
        shouldBe: (value, errorMessage: string) => {
            if (platformValidators.date.shouldBe(value) == null) {
                return;
            }

            return [errorMessage];
        }
    },

    string: {
        notEmpty: (value, errorMessage: string) => {
            if (value != null && value !== '') {
                return;
            }

            return [errorMessage];
        }
    },

    attrQuery: {
        isDisabled: function (value: { disabled?: boolean }) {
            return value.disabled;
        },

        notEmpty: function (value) {
            if (validators.attrQuery.isDisabled(value)) {
                return;
            }

            if (value == null || value.length === 0) {
                //if ((value == null) || (value.length === 0) || (value.length === 1 && value[0].fakeLL === true)) {
                return ['At least one attribute should be specified'];
            }
        },

        //LL: 23.12.20: uncommented, add analyze "expression"
        //LL: was commented by OE 23.07.19 ver 105 in Vault with comment "Allow None aggregation for charts"
        //LL: Either all or none of attributes must have aggregation function
        aggregationsNoneOrAll: function (value) {
            if (validators.attrQuery.isDisabled(value)) {
                return;
            }

            //LL: 29.12.20:  #Delta, #DeltaPCT
            //   Irina:
            //   The result of it the validation fails in cards when we calculate actual balance
            //   Virtual Attribute #Delta should not have aggregation, but it demands.

            //LL: 23.12.20:  attribute vs expression
            //    "expression" can have its own aggregation, frontend cannot analyze it, it will be done further by backend

            var find0 = value.find((obj) => {
                if (obj.attribute === '#Delta' || obj.attribute === '#DeltaPCT') {
                    return false;
                }
                //return obj.attribute != null && obj.aggregateGroup == null;
                //LL: 26.10.23: "none" is set when attr is created, but actually it is null
                return obj.attribute != null && (obj.aggregateGroup == null || obj.aggregateGroup === 'none');
            });

            var find1 = value.find((obj) => {
                if (obj.attribute === '#Delta' || obj.attribute === '#DeltaPCT') {
                    return false;
                }
                //return obj.aggregateGroup != null; //LL: both attribute and expression  //LL: 25.10.23: Why ?
                //LL: 25.10.23: "none" is set when attr is created, but actually it is null
                return obj.attribute != null && !(obj.aggregateGroup == null || obj.aggregateGroup === 'none');
            });

            if (find0 != null && find1 != null) {
                return [
                    'Either all or none of Attributes (with the exception of Expressions) must have aggregation function'
                ];
            }
        }
    }
};
